// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mi-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
}
.mi-thumb {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  cursor: zoom-in;
  transition:
    box-shadow 0.15s ease,
    transform 0.15s ease;
}
.mi-thumb:hover {
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.12);
  transform: translateY(-1px);
}
.mi-thumb .ant-image-img {
  object-fit: cover;
  object-position: top left;
  display: block;
}
.mi-page {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  line-height: 16px;
  color: #fff;
  background: rgba(17, 24, 39, 0.65);
  pointer-events: none;
}

/* Увеличение при наведении */
.mi-pop .ant-popover-inner {
  padding: 6px;
  border-radius: 10px;
}
.mi-zoom {
  margin: 0;
  width: min(560px, 80vw);
}
.mi-zoom img {
  display: block;
  width: 100%;
  max-height: 60vh;
  object-fit: contain;
  border-radius: 6px;
  background: #f9fafb;
}
.mi-zoom figcaption {
  margin: 6px 4px 2px;
  font-size: 12px;
  line-height: 1.4;
  color: #6b7280;
}
@media (hover: none) {
  .mi-pop {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .mi-thumb {
    transition: none;
  }
  .mi-thumb:hover {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/test-chat/ui/message-images.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf;;wBAEsB;AACxB;AACA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".mi-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 4px;\n}\n.mi-thumb {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  cursor: zoom-in;\n  transition:\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n.mi-thumb:hover {\n  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.12);\n  transform: translateY(-1px);\n}\n.mi-thumb .ant-image-img {\n  object-fit: cover;\n  object-position: top left;\n  display: block;\n}\n.mi-page {\n  position: absolute;\n  right: 6px;\n  bottom: 6px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  line-height: 16px;\n  color: #fff;\n  background: rgba(17, 24, 39, 0.65);\n  pointer-events: none;\n}\n\n/* Увеличение при наведении */\n.mi-pop .ant-popover-inner {\n  padding: 6px;\n  border-radius: 10px;\n}\n.mi-zoom {\n  margin: 0;\n  width: min(560px, 80vw);\n}\n.mi-zoom img {\n  display: block;\n  width: 100%;\n  max-height: 60vh;\n  object-fit: contain;\n  border-radius: 6px;\n  background: #f9fafb;\n}\n.mi-zoom figcaption {\n  margin: 6px 4px 2px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n@media (hover: none) {\n  .mi-pop {\n    display: none;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .mi-thumb {\n    transition: none;\n  }\n  .mi-thumb:hover {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
